import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  tooltip: ({ maxWidth }: { maxWidth?: number }) => ({
    ...(maxWidth !== undefined ? { maxWidth } : {}),
    padding: '11px 13px',
    color: '#fff',
    fontFamily: 'Open Sans, sans-serif',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    backgroundColor: '#282828',
    borderRadius: 4,
    border: 'none',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    opacity: 1,
  }),
  arrow: {
    color: '#282828',
    opacity: 1,
  },
});
